import { render, staticRenderFns } from "./Consortium.vue?vue&type=template&id=1562b9ea&scoped=true&"
import script from "./Consortium.vue?vue&type=script&lang=js&"
export * from "./Consortium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1562b9ea",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/sessions/sections/Consortium.vue
// module id = 1543
// module chunks = 0